import {createContext} from 'react';

export interface DropdownContextState<T = any> {
	toggled: boolean;
	currentValue: T[];
	multiselect: boolean;
	dropdownRef: HTMLElement | null;
}

export interface DropdownContextActions<T = any> {
	onOptionClick: (value: T) => void;
}

export type DropdownContextType<T = any> = DropdownContextState & DropdownContextActions<T>;

export const DropdownContext = createContext<DropdownContextType | null>(null);
DropdownContext.displayName = 'DropdownContext';
export default DropdownContext;
